import type { WidgetConfig } from '@examdojo/core/widget';
import { FUNCTION_MACHINE_DEFAULT_PRESET } from './default.preset';

export const FUNCTION_MACHINE_PRESETS: WidgetConfig[] = [FUNCTION_MACHINE_DEFAULT_PRESET];

export { FUNCTION_MACHINE_DEFAULT_PRESET };
